import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';
import TextInput from '../common/TextInput';
import { map } from 'lodash';
import { imageBasePath } from '../../constants/staticData';
import InspectionRequired from './inspectionRequired';

class CustomPanel extends Component {
  constructor(props) {
    super(props);
    let count = 0;
    map(props.carServiceData, (val) => {
      if (val.status) {
        count += 1;
      }
    });
    let panelOpen = false;
    if (props.carServiceData.length && props.carServiceData[0] && props.carServiceData[0].parentTitle == "Car Servicing") {
      panelOpen = true;
    }
    this.state = {
      panelOpen: panelOpen,
      checkedCount: count,
      panelClick: false,
      content: [{
      }]
    };
  }
  componentWillReceiveProps(nextProps) {
    let count = 0;
    map(nextProps.carServiceData, (val) => {
      if (val.status) {
        count += 1;
      }
    });
    this.setState({ checkedCount: count });
  }
  render() {
    const { title, carServiceData, checkboxClick, priceChanged, descpChanged,checkInspection, onChangeToggleInsp, onInspecPriceChange } = this.props;
    return (
      <div className="custom-panel">
        <Panel collapsible expanded={this.state.panelOpen} header={
          <div onClick={() => this.setState({ panelOpen: !this.state.panelOpen })}>
            <img className="panel-logo" src={carServiceData && carServiceData.length && carServiceData[0].parentTitle=='Car Servicing' ? `${imageBasePath}/carservice.png` :  carServiceData[0].parentImage ? carServiceData[0].parentImage : `${imageBasePath}/placeholder.png`} alt="" />
            <h5 className="panel-name">{title}</h5>
            <span className="panel-heading-right">
              <span className="category-selected-count">{this.state.checkedCount > 0 ? `${this.state.checkedCount} selected` : ""}</span>
              <span className="category-count">{carServiceData && carServiceData.length > 0 ? `${carServiceData.length} subcategories` : ""}</span>
              <i className={this.state.panelOpen ? "mdi mdi-chevron-up" : "mdi mdi-chevron-down"} />
            </span>
          </div>} eventKey="1">

          {map(carServiceData, (serviceData, key) => {
            return (
              <div key={key} className="cartype-auto">
              <div className="">
                <span className="checkbox-holder checkbox-style" >
                  <input type="checkbox" id={serviceData.id} checked={serviceData.status ? true : false} onChange={(checked) => {
                    checkboxClick(serviceData.id, checked);
                  }} />
                  <label htmlFor={serviceData.id} className="custom-checkbox checkbox-name" >{serviceData.serviceTitle}</label>
                </span>
              </div>
              <div className="car-type-section">
                <span className="car-type-sedan ">Sedan</span>
                <div className="price-holder car-type-price-holder">
                  <span className="currency">AED</span>
                  <TextInput type="mobile"
                    customClass={serviceData.cost_sedan ? "ms-input focus" : "ms-input"}
                    label="Price"
                    name="name"
                    value={serviceData.cost_sedan}
                    min="0"
                    onChange={(text) => { priceChanged('sedan', Number(text), serviceData.id); }}
                  />
                </div>
                <div className="price-holder car-type-descp-holder">
                  <TextInput type="text"
                    customClass={serviceData.descp_sedan ? "ms-input focus" : "ms-input"}
                    label="Add Description"
                    name="name"
                    value={serviceData.descp_sedan ? serviceData.descp_sedan : ''}
                    onChange={(text) => { descpChanged('sedan', text, serviceData.id);}}
                  />
                </div>
                {(serviceData.descp_sedan.length > 200) ? <p className="descp-err">Should be less than 200 characrers</p> : ''}
              </div>
              <div className="car-type-section">
                <span className="car-type-suv">SUV</span>
                <div className="price-holder car-type-price-holder">
                  <span className="currency">AED</span>
                  <TextInput type="mobile"
                    customClass={serviceData.cost_suvs ? "ms-input focus" : "ms-input"}
                    label="Price"
                    name="name"
                    value={serviceData.cost_suvs}
                    min="0"
                    onChange={(text) => { priceChanged('suv', Number(text), serviceData.id); }}
                  />
                </div>
                <div className="price-holder car-type-descp-holder">
                  <TextInput type="text"
                    customClass={serviceData.descp_suv ? "ms-input focus" : "ms-input"}
                    label="Add Description"
                    name="name"
                    value={serviceData.descp_suv ? serviceData.descp_suv : ''}
                    onChange={(text) => { descpChanged('suv', text, serviceData.id); }}
                  />
                </div>
                {(serviceData.descp_suv.length > 200) ? <p className="descp-err">Should be less than 200 characrers</p> : ''}
              </div>
              {/*<InspectionRequired 
              serviceInfo={serviceData} 
              checkInspection={checkInspection} 
              onChangeToggleInsp={onChangeToggleInsp}
              onInspecPriceChange={onInspecPriceChange}/>*/}
              </div>
            );         
          })}
        </Panel>
      </div>
    );
  }
}

export default CustomPanel;



// WEBPACK FOOTER //
// ./src/components/ManageServices/CustomPanel.jsx